// Loan maths. All rates are annual %.

export function reducingEMI(P, annualRate, months) {
  const r = annualRate / 12 / 100;
  const n = months;
  if (r === 0) return P / n;
  const f = Math.pow(1 + r, n);
  return (P * r * f) / (f - 1);
}

export function flatEMI(P, flatRate, months) {
  const years = months / 12;
  const interest = (P * flatRate * years) / 100;
  return (P + interest) / months;
}

// Equivalent reducing-balance annual rate that produces the same EMI as a flat rate.
export function equivReducingFromFlat(P, flatRate, months) {
  const target = flatEMI(P, flatRate, months);
  let lo = 0.0001, hi = 100;
  for (let i = 0; i < 100; i++) {
    const mid = (lo + hi) / 2;
    const emi = reducingEMI(P, mid, months);
    if (emi > target) hi = mid; else lo = mid;
  }
  return (lo + hi) / 2;
}

// Equivalent flat annual rate that costs the same as a reducing-balance rate.
export function equivFlatFromReducing(P, reducingRate, months) {
  const emi = reducingEMI(P, reducingRate, months);
  const years = months / 12;
  return ((emi * months - P) / (P * years)) * 100;
}

// Max loan for a given comfortable EMI on a reducing basis.
export function affordablePrincipal(emi, annualRate, months) {
  const r = annualRate / 12 / 100;
  const n = months;
  if (r === 0) return emi * n;
  const f = Math.pow(1 + r, n);
  return (emi * (f - 1)) / (r * f);
}

export function round(n) {
  return Math.round(n);
}

export function floorTo(n, step) {
  return Math.floor(n / step) * step;
}
